function JournalIllustration() {
  return (
    <div className="illus illus--journal" aria-hidden="true">
      <div className="illus__window">
        <div className="illus__titlebar">
          <span />
          <span />
          <span />
          <span className="illus__titlebar-text">Bitácora · Marzo 2026</span>
        </div>
        <table className="illus-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Símbolo</th>
              <th>Tipo</th>
              <th>P&amp;L</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>24/03</td>
              <td>TSLA</td>
              <td>
                <span className="illus-badge illus-badge--buy">Call</span>
              </td>
              <td className="illus-positive">+$312</td>
            </tr>
            <tr>
              <td>23/03</td>
              <td>MSFT</td>
              <td>
                <span className="illus-badge illus-badge--sell">Venta</span>
              </td>
              <td className="illus-positive">+$89</td>
            </tr>
            <tr>
              <td>22/03</td>
              <td>QQQ 380P</td>
              <td>
                <span className="illus-badge illus-badge--buy">Put</span>
              </td>
              <td className="illus-negative">-$156</td>
            </tr>
            <tr>
              <td>21/03</td>
              <td>AMD</td>
              <td>
                <span className="illus-badge illus-badge--buy">Acción</span>
              </td>
              <td className="illus-positive">+$540</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default JournalIllustration;
